var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 40L74 40",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 17L74.3333 40.3333L51 63.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-basket",
    viewBox: "0 0 16 8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3536 4.35355C15.5488 4.15829 15.5488 3.84171 15.3536 3.64645L12.1716 0.464466C11.9763 0.269204 11.6597 0.269204 11.4645 0.464466C11.2692 0.659728 11.2692 0.976311 11.4645 1.17157L14.2929 4L11.4645 6.82843C11.2692 7.02369 11.2692 7.34027 11.4645 7.53553C11.6597 7.7308 11.9763 7.7308 12.1716 7.53553L15.3536 4.35355ZM0 4.5H15V3.5H0V4.5Z",
    fill: "white"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-link",
    viewBox: "0 0 16 9",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3536 4.85355C15.5488 4.65829 15.5488 4.34171 15.3536 4.14645L12.1716 0.964466C11.9763 0.769204 11.6597 0.769204 11.4645 0.964466C11.2692 1.15973 11.2692 1.47631 11.4645 1.67157L14.2929 4.5L11.4645 7.32843C11.2692 7.52369 11.2692 7.84027 11.4645 8.03553C11.6597 8.2308 11.9763 8.2308 12.1716 8.03553L15.3536 4.85355ZM0 5H15V4H0V5Z"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-slider",
    viewBox: "0 0 20 8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3536 4.35356C19.5488 4.1583 19.5488 3.84171 19.3536 3.64645L16.1716 0.464469C15.9763 0.269207 15.6597 0.269207 15.4645 0.464469C15.2692 0.659731 15.2692 0.976314 15.4645 1.17158L18.2929 4L15.4645 6.82843C15.2692 7.02369 15.2692 7.34027 15.4645 7.53554C15.6597 7.7308 15.9763 7.7308 16.1716 7.53554L19.3536 4.35356ZM-9.90792e-08 4.5L19 4.5L19 3.5L9.90792e-08 3.5L-9.90792e-08 4.5Z",
    fill: "white"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-top",
    viewBox: "0 0 20 21",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66782 14.8737C1.87421 15.0572 2.19025 15.0386 2.37371 14.8322L10 6.25259L17.6263 14.8322C17.8098 15.0386 18.1258 15.0572 18.3322 14.8737C18.5386 14.6902 18.5572 14.3742 18.3737 14.1678L10 4.74739L1.6263 14.1678C1.44284 14.3742 1.46143 14.6902 1.66782 14.8737Z",
    fill: "black"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-border-one",
    viewBox: "0 0 158 55",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.2383 53.4843C110.295 50.844 168.844 40.417 154.59 19.8313C136.773 -5.90074 65.1225 1.19207 40.6594 4.56532C16.1964 7.93856 -12.2424 22.874 6.63375 41.0889C21.7347 55.6608 80.3307 47.8001 107.741 42.0483",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-border-two",
    viewBox: "0 0 93 46",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.7604 44.9501C49.8366 45.0352 92.255 41.4376 92.4448 22.2782C92.6006 6.53855 63.7344 1.40165 46.3917 1.1936C30.3488 1.00114 1.39012 6.12562 1.24107 21.1793C1.05809 39.6585 47.4602 41.536 64.0435 36.3089",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-open",
    viewBox: "0 0 64 64",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53 21H11c-1.7 0-3-1.3-3-3s1.3-3 3-3h42c1.7 0 3 1.3 3 3s-1.3 3-3 3zM53 35H11c-1.7 0-3-1.3-3-3s1.3-3 3-3h42c1.7 0 3 1.3 3 3s-1.3 3-3 3zM53 49H11c-1.7 0-3-1.3-3-3s1.3-3 3-3h42c1.7 0 3 1.3 3 3s-1.3 3-3 3z",
    fill: "white",
    opacity: 1,
    "data-original": "white"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-close",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 36.6663C29.2034 36.6663 36.6654 29.2044 36.6654 19.9997C36.6654 10.7949 29.2034 3.33301 19.9987 3.33301C10.794 3.33301 3.33203 10.7949 3.33203 19.9997C3.33203 29.2044 10.794 36.6663 19.9987 36.6663Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15L15 25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L25 25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-navigation-arrow",
    viewBox: "0 0 29 28",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 21L11 14L18 7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-basket",
    viewBox: "0 0 34 34",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7526 31.1654C13.535 31.1654 14.1693 30.5311 14.1693 29.7487C14.1693 28.9663 13.535 28.332 12.7526 28.332C11.9702 28.332 11.3359 28.9663 11.3359 29.7487C11.3359 30.5311 11.9702 31.1654 12.7526 31.1654Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3307 31.1654C29.1131 31.1654 29.7474 30.5311 29.7474 29.7487C29.7474 28.9663 29.1131 28.332 28.3307 28.332C27.5483 28.332 26.9141 28.9663 26.9141 29.7487C26.9141 30.5311 27.5483 31.1654 28.3307 31.1654Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 1.41797H7.08073L10.8774 20.3871C11.0069 21.0394 11.3618 21.6252 11.8798 22.0422C12.3977 22.4592 13.0459 22.6807 13.7107 22.668H27.4807C28.1456 22.6807 28.7937 22.4592 29.3117 22.0422C29.8297 21.6252 30.1845 21.0394 30.3141 20.3871L32.5807 8.5013H8.4974",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-coin-ru",
    viewBox: "0 0 12 38",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.216 25.768C9.632 25.768 10 25.896 10.32 26.152C10.64 26.408 10.8 26.728 10.8 27.112C10.8 27.528 10.432 27.864 9.696 28.12C8.992 28.408 7.744 28.648 5.952 28.84C5.952 29.736 5.984 30.856 6.048 32.2L6.096 35.272C6.096 35.88 5.968 36.36 5.712 36.712C5.456 37.064 5.056 37.24 4.512 37.24C4.16 37.24 3.872 37.096 3.648 36.808C3.456 36.488 3.36 36.104 3.36 35.656L3.456 29.032L1.92 29.08C1.472 29.08 1.088 28.952 0.768 28.696C0.48 28.408 0.336 28.072 0.336 27.688C0.336 27.304 0.72 26.968 1.488 26.68C1.648 26.616 1.904 26.52 2.256 26.392C2.64 26.264 3.056 26.168 3.504 26.104L3.6 20.44C3.152 20.472 2.592 20.488 1.92 20.488C1.408 20.488 1.008 20.424 0.72 20.296C0.464 20.168 0.336 19.928 0.336 19.576C0.336 19.416 0.384 19.336 0.48 19.336C0.576 19.304 0.736 19.288 0.96 19.288C1.184 19.288 1.36 19.288 1.488 19.288C2 19.288 2.704 19.176 3.6 18.952V18.52C3.6 11.064 3.184 5.352 2.352 1.384C2.832 0.647998 3.44 0.279998 4.176 0.279998C5.36 0.279998 6.432 0.551998 7.392 1.096C8.384 1.608 9.2 2.312 9.84 3.208C11.088 5.064 11.712 7.144 11.712 9.448C11.712 11.848 11.2 13.992 10.176 15.88C9.152 17.768 7.664 19.24 5.712 20.296C5.712 21.576 5.76 23.448 5.856 25.912L8.16 25.816C8.48 25.816 8.688 25.816 8.784 25.816C8.912 25.784 9.056 25.768 9.216 25.768ZM5.04 2.824C5.04 4.456 5.136 6.984 5.328 10.408L5.616 17.992C6.864 16.808 7.776 15.576 8.352 14.296C8.96 12.984 9.264 11.512 9.264 9.88V9.832C9.264 9.096 9.184 8.168 9.024 7.048C8.928 6.664 8.752 6.28 8.496 5.896C8.24 5.512 8.096 5.288 8.064 5.224C7.84 4.904 7.248 4.408 6.288 3.736L5.04 2.824Z",
    fill: "black"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-basket-button",
    viewBox: "0 0 34 34",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7526 31.1654C13.535 31.1654 14.1693 30.5311 14.1693 29.7487C14.1693 28.9663 13.535 28.332 12.7526 28.332C11.9702 28.332 11.3359 28.9663 11.3359 29.7487C11.3359 30.5311 11.9702 31.1654 12.7526 31.1654Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3307 31.1654C29.1131 31.1654 29.7474 30.5311 29.7474 29.7487C29.7474 28.9663 29.1131 28.332 28.3307 28.332C27.5483 28.332 26.9141 28.9663 26.9141 29.7487C26.9141 30.5311 27.5483 31.1654 28.3307 31.1654Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 1.41797H7.08073L10.8774 20.3871C11.0069 21.0394 11.3618 21.6252 11.8798 22.0422C12.3977 22.4592 13.0459 22.6807 13.7107 22.668H27.4807C28.1456 22.6807 28.7937 22.4592 29.3117 22.0422C29.8297 21.6252 30.1845 21.0394 30.3141 20.3871L32.5807 8.5013H8.4974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-basket-close",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 36.6654C29.2034 36.6654 36.6654 29.2034 36.6654 19.9987C36.6654 10.794 29.2034 3.33203 19.9987 3.33203C10.794 3.33203 3.33203 10.794 3.33203 19.9987C3.33203 29.2034 10.794 36.6654 19.9987 36.6654Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15L15 25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L25 25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-name-border",
    viewBox: "0 0 152 41",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.647 6.91528C93.8092 1.9137 7.78197 -2.57562 1.69319 17.1962C-4.39558 36.968 40.0912 44.4907 120.096 37.0972C182.576 31.3233 136.758 -1.81754 94.2506 0.981744",
    stroke: "#419197",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-name-border-white",
    viewBox: "0 0 112 42",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.269 6.42206C68.3233 2.19874 4.8703 -0.00759983 1.21929 19.5574C-2.43172 39.1224 30.5988 45.3691 89.126 36.0646C134.833 28.7983 99.7522 -2.56275 68.6089 1.27258",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkmark",
    viewBox: "0 0 129 128",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M117.835 59.1242V64.0309C117.828 75.5318 114.104 86.7225 107.218 95.9339C100.332 105.145 90.6521 111.884 79.6232 115.145C68.5943 118.406 56.8067 118.014 46.0185 114.029C35.2303 110.043 26.0195 102.677 19.7598 93.0285C13.5001 83.3804 10.5269 71.9672 11.2836 60.4912C12.0403 49.0152 16.4864 38.0913 23.9588 29.3486C31.4312 20.6059 41.5295 14.5129 52.7476 11.9783C63.9658 9.4437 75.7027 10.6033 86.208 15.2842",
    stroke: "#419197",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.833 21.333L64.5 74.7197L48.5 58.7197",
    stroke: "#419197",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-popup",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.33079 7.99998L15.724 1.60677C16.092 1.23878 16.092 0.643981 15.724 0.275992C15.356 -0.0919973 14.7612 -0.0919973 14.3932 0.275992L8.00002 6.66921L1.60677 0.275992C1.23878 -0.0919973 0.643981 -0.0919973 0.275992 0.275992C-0.0919973 0.643981 -0.0919973 1.23878 0.275992 1.60677L6.66921 7.99998L0.275992 14.3932C-0.0919973 14.7612 -0.0919973 15.356 0.275992 15.724C0.36328 15.8115 0.466995 15.8809 0.581181 15.9282C0.695367 15.9755 0.817776 15.9998 0.941379 15.9997C1.18231 15.9997 1.42324 15.9075 1.60677 15.724L7.99998 9.33076L14.3932 15.724C14.4805 15.8115 14.5842 15.8809 14.6984 15.9282C14.8126 15.9755 14.935 15.9998 15.0586 15.9997C15.2995 15.9997 15.5405 15.9075 15.724 15.724C16.092 15.356 16.092 14.7612 15.724 14.3932L9.33079 7.99998Z",
    fill: "#919191"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-reverse",
    viewBox: "0 0 21 21",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5 8.5-4 4 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 12.5h-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5.5 4 4-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 4.5h-12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.a012cc859b5e1777a8e7a0a5ec876b36.svg";
export { ForwardRef as ReactComponent };